import React from "react";
import "./connectView.css";
import Heading from "../Heading";
import swal from "sweetalert2";
import axios from "axios";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/libphonenumber.js";
import "react-intl-tel-input/dist/main.css";
import { validationForEmail } from "../../js/regex";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { Parallax } from "react-parallax";
import ContentPage from "../content-page";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import ReactPixel from "react-facebook-pixel";
import ReCAPTCHA from "reaptcha";
import FormPopup from "../formPopup";


const image1 = "https://winpeforum.com/assets/elements/HeroImg.jpg";
const handler = (status, value, countryData, number, id) => {
  // // console.log(status, value, countryData, number, id)
};

const genderOptions = ["Male", "Female", "Other"];

export class ConnectComponent extends React.Component {
  constructor(args) {
    super(args);
    this.inputs = [
      "firstName",
      "lastName",
      "email",
      "company",
      "number",
      "gender",
    ];
    this.state = {
      Error: {},
      values: {},
      country: " ",
      region: " ",
      isChange: true,
      isVerify: true,
      showPopup: false,
      popupMessage: "",
    };
  }

  componentDidMount() {
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
  }
  selectCountry(val) {
    this.setState({
      values: {
        ...this.state.values,
        country: val,
      },
      isChange: false,
    });
    setTimeout(() => {
      this.setState({
        isChange: true,
      });
    }, 1000);
  }

  selectRegion(val) {
    this.setState({
      values: {
        ...this.state.values,
        region: val,
      },
      isChange: false,
    });
    setTimeout(() => {
      this.setState({
        isChange: true,
      });
    }, 1000);
  }
  handleChangeAndValidation = (key, e) => {
    let { Error } = this.state;
    this.setState({
      values: {
        ...this.state.values,
        [key]: e.target.value.trim(),
      },
    });
    delete Error[key];
  };
 
  handleSubmit = (e) => {
    e.preventDefault();

    const { values, isVerify } = this.state;
    let isFlag = false;
    let error = {};
    this.inputs.map((item, j) => {
      if (!values[item]) {
        isFlag = true;
        error[item] = true;
      } else if (item === "email") {
        error[item] = !validationForEmail(values[item]);
        isFlag = isFlag === true ? true : error[item];
      }
    });
    isFlag = isFlag ? true : !isVerify;
    error["isVerify"] = !isVerify;
    // console.log("values", values, error)

    // isFlag = false;
    if (isFlag) {
      this.setState({
        Error: error,
      });
    } else {
      const {
        firstName,
        lastName,
        designation,
        company,
        email,
        number,
        wnumber,
        sector,
        country,
        region,
        // institution,
        gender,
        message,
      } = values;

      const data = {
        first_name: firstName,
        last_name: lastName,
        designation,
        company,
        email,
        mobile_number: number,
        whatsapp_number: wnumber,
        sector,
        country,
        state_or_city: region,
        // institution,
        message,
        gender,
      };

      console.log(data);
      ReactPixel.track("Contact");
      axios
        .post(`https://winpeforum.com/api/public/index.php/connect`, data)
        .then((response) => {
          this.showFormPopup();
          document.getElementById("reset").reset();
          return response;
        })
        .catch((e) => {
          const { data, status } = e.response;

          
        });
    }
  };

  onPopUpClose = () => {
    this.setState({
      showPopup: false,
      popupMessage: "",
    });
  };

  showFormPopup(text = "") {
    this.setState({
      showPopup: true,
      popupMessage: text,
    });
  }

  render() {
    const insideStyles = {
      background: "white",
      padding: 20,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
    };
    const { Error, values, isVerify, showPopup, popupMessage } = this.state;

    return (
      <div>
        <FormPopup
          show={showPopup}
          text={popupMessage}
          onPopupClose={this.onPopUpClose}
        />
        <ContentPage>
          <div className="section__content">
            <Parallax bgImage={image1} strength={500}>
              <div style={{ height: "100%" }} className="connect__wrapper">
                <div className="connect__section">
                  <ScrollAnimation
                    delay={0}
                    duration={2}
                    animateIn="slideInRight"
                    offset={600}
                  >
                    <div className="connect_content">
                      <div className="left_section">
                        <div className="left_content">
                          <div className="">
                            <Heading title="Connect" />
                          </div>
                          <div className="low__heading"></div>
                          <div className="policy_new">
                            Write to us at info@winpeforum.com
                          </div>
                        </div>
                      </div>
                      <div className="right_section">
                        <div className="right_content">
                          <div className="connect_form">
                            <form onSubmit={this.handleSubmit} id="reset">
                              <div className="row">
                              
                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                   
                                    <div className="st">FIRST NAME *</div>
                                    <textarea
                                      onChange={(e) =>
                                        this.handleChangeAndValidation(
                                          "firstName",
                                          e
                                        )
                                      }
                                      name="firstName"
                                      id="firstName"
                                      className="form-control"
                                      placeholder="Enter First Name"
                                     
                                    />
                                    {Error.firstName ? (
                                      <span className="error">
                                        Enter first name.
                                      </span>
                                    ) : (
                                      " "
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                    <div className="st">LAST NAME *</div>
                                    <textarea
                                      type="text"   
                                      onChange={(e) =>
                                        this.handleChangeAndValidation(
                                          "lastName",
                                          e
                                        )
                                      }
                                      name="lastName"
                                      id="lastName"
                                      className="form-control"
                                      placeholder="Enter Last Name"
                                    />
                                    {Error.lastName ? (
                                      <span className="error">
                                        Enter last name.
                                      </span>
                                    ) : (
                                      " "
                                    )}
                                  </div>
                                </div>

                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                    <div className="st">GENDER *</div>
                                    <select
                                      name="gender"
                                      id="gender"
                                      onChange={(e) =>
                                        this.handleChangeAndValidation(
                                          "gender",
                                          e
                                        )
                                      }
                                      className="form-control"
                                    >
                                      <option
                                        selected
                                        style={{ display: "none" }}
                                      >
                                        --- SELECT GENDER ---
                                      </option>

                                      {genderOptions.map((gender, i) => (
                                        <option value={gender}>{gender}</option>
                                      ))}
                                    </select>
                                    {Error.gender ? (
                                      <span className="error">
                                        Please select gender.
                                      </span>
                                    ) : (
                                      " "
                                    )}
                                  </div>
                                </div>

                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                    <div className="st">DESIGNATION</div>
                                    <textarea
                                      type="text"
                                      onChange={(e) =>
                                        this.handleChangeAndValidation(
                                          "designation",
                                          e
                                        )
                                      }
                                      name="designation"
                                      id="designation"
                                      className="form-control"
                                      placeholder="Enter Position/ Title"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                    <div className="st">COMPANY *</div>
                                    <textarea
                                      type="text"
                                      onChange={(e) =>
                                        this.handleChangeAndValidation(
                                          "company",
                                          e
                                        )
                                      }
                                      name="company"
                                      id="company"
                                      className="form-control"
                                      placeholder="Enter Company Name"
                                    />
                                    {Error.company ? (
                                      <span className="error">
                                        Enter the name of your current
                                        organisation.
                                      </span>
                                    ) : (
                                      " "
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                    <div className="st">EMAIL ADDRESS *</div>
                                    <textarea
                                      type="email"
                                      onChange={(e) =>
                                        this.handleChangeAndValidation(
                                          "email",
                                          e
                                        )
                                      }
                                      name="email"
                                      id="email"
                                      className="form-control"
                                      placeholder="Preferred Email ID"
                                    />
                                    {Error.email ? (
                                      <span className="error">
                                        Enter a valid email address.
                                      </span>
                                    ) : (
                                      " "
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                    <div className="st">MOBILE NUMBER *</div>
                                    <textarea
                                      className="form-control"
                                      placeholder="Mobile Number"
                                      onPhoneNumberChange={(
                                        status,
                                        value,
                                        countryData,
                                        number,
                                        id
                                      ) =>
                                        this.setState({
                                          values: { ...values, number: number },
                                        })
                                      }
                                      onPhoneNumberBlur={handler}
                                      onChange={(e) =>
                                        this.setState({
                                          values: {
                                            ...values,
                                            number: e.target.value,
                                          },
                                        })
                                      }
                                      defaultCountry="in"
                                      Default={["in"]}
                                      css={["intl-tel-input", "form-control"]}
                                      utilsScript={"libphonenumber.js"}
                                      name="number"
                                    />

                                    {Error.number ? (
                                      <span className="error">
                                        Please enter number.
                                      </span>
                                    ) : (
                                      " "
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                    <div className="st">WHATSAPP NUMBER</div>
                                    <textarea
                                      type="text"
                                      onChange={(e) =>
                                        this.handleChangeAndValidation(
                                          "wnumber",
                                          e
                                        )
                                      }
                                      name="wnumber"
                                      id="wnumber"
                                      className="form-control"
                                      placeholder="If Different From Mobile Number"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                    <div className="st">
                                      SECTOR/ AREAS OF EXPERTISE
                                    </div>
                                    <textarea
                                      type="text"
                                      onChange={(e) =>
                                        this.handleChangeAndValidation(
                                          "sector",
                                          e
                                        )
                                      }
                                      name="sector"
                                      id="sector"
                                      className="form-control"
                                      placeholder="Enter Sector/ Areas Of Expertise"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                    <div className="st">COUNTRY</div>
                                    <CountryDropdown
                                      className="form-control"
                                      value={this.state.values.country}
                                      onChange={(val) =>
                                        this.selectCountry(val)
                                      }
                                      name="country"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                  <div className="form-group">
                                    <div className="st">STATE / CITY</div>
                                    <RegionDropdown
                                      className="form-control"
                                      country={this.state.values.country}
                                      value={this.state.values.region}
                                      onChange={(val) => this.selectRegion(val)}
                                      name="region"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-10">
                                  <div className="msg">
                                    <div className="st">
                                      MESSAGE (max. 250 words){" "}
                                    </div>
                                    <textarea
                                      name="message"
                                      onChange={(e) =>
                                        this.handleChangeAndValidation(
                                          "message",
                                          e
                                        )
                                      }
                                      id="message"
                                      className="form-control"
                                      rows="3"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div
                                    style={{
                                      marginTop: "30px",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {" "}
                                    <input type="checkbox" />
                                    &nbsp;&nbsp;I agree to receive email
                                    communications from Winpe, including news
                                    about our conferences, and access to
                                    exclusive invite-only events.
                                  </div>
                                </div>
                               
                                <div className="col-md-12">
                                  <div className="s_btn">
                                    <button onClick={this.handleSubmit}>
                                      SUBMIT
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                            <div className="policy">
                              By clicking 'Submit', you agree to the Privacy
                              Policy regarding storage of this information in
                              the Winpe database.
                            </div>
                            {/*
													<div>
														<a href="javascript:void(window.open(
															'https://form.jotform.com/200172100562437',
															'blank',
															'scrollbars=yes,
															toolbar=no,
															width=700,
															height=500'
															))
														">FeedBack Servey</a>
													</div>
													*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </ScrollAnimation>
                </div>
              </div>
            </Parallax>
          </div>
        </ContentPage>
      </div>
    );
  }
}

export default ConnectComponent;



// WEBPACK FOOTER //
// ./src/components/ConnectComponent/index.js